import React, { useEffect, useRef, useState } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';
import './index.scss';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { MENU_CHECK_LANG, MENU_CHECK_PATH } from '../../../constants/defaults';
import { useLocation } from 'react-router-dom';

const MenuAccordian = ({
  menuList = [],
  memberMenuList = [],
  userPoints = 0.0,
  isFromFooter = false
}) => {
  const [expandedItems, setExpandedItems] = useState(-1);
  const getIsDesktop = () =>
    typeof window !== 'undefined' ? window?.innerWidth >= 1024 : false;
  const [isDesktop, setIsDesktop] = useState(getIsDesktop());
  const ref = useRef(null);
  const { t, i18n } = useTranslation();
  const { pathname = '' } = useLocation();
  let lang = i18n.language;
  let isEs = _.isEqual(lang, 'es');
  let rendererMenu = [];
  let condition = '';
  let pathCondition = '';

  _.map(menuList, item => {
    condition = '';
    _.map(item?.links, item => {
      if (_.isEmpty(item.check)) {
        condition = true;
      } else {
        _.map(item.check, checkCondition => {
          switch (checkCondition) {
            case MENU_CHECK_PATH:
              pathCondition =
                pathname.match(/^\/prescription\/[A-Za-z0-9-_]*$/) ||
                pathname.match(/^\/es\/medicamento\/[A-Za-z0-9-_]*$/);
              pathCondition = _.isEmpty(pathCondition) ? false : true;
              condition = _.isEmpty(condition)
                ? pathCondition
                : condition && pathCondition;
              break;
            case MENU_CHECK_LANG:
              condition = _.isEmpty(condition)
                ? _.isEqual(lang.toString(), 'en')
                : _.isEqual(lang.toString(), 'en') && condition;
              break;
          }
        });
      }
    });
    condition && rendererMenu.push(item);
  });

  const handleKeydownEvent = (e, index) => {
    if (e.key === 'Enter' || e.key === ' ') {
      if (ref?.current && ref?.current[index]) ref.current[index].click();
    }
  };

  const handleAccordionChange = index => {
    setExpandedItems(index === expandedItems ? -1 : index);
  };

  const handleKeydownEventForAccordian = (e, index) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleAccordionChange(index);
    }
  };

  useEffect(() => {
    const onResize = () => {
      setIsDesktop(getIsDesktop());
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const getTitle = name => {
    if (name === 'Pharma marketers & agencies') {
      return isDesktop ? 'Pharma marketers' : 'Pharma marketers & agencies';
    } else return name;
  };

  return (
    <>
      {memberMenuList &&
        memberMenuList?.map((item, index) => {
          return (item.name == 'Coupons' ||
            item.name == 'Drugs' ||
            item.name == 'Profile') &&
            !isEs ? (
            <div className="loggedInTabs" key={index}>
              <a href={item.url} key={index} className="adaMenu whiteFocus">
                <span>
                  <img src={item.icon} height={28} width={28} alt="" />
                </span>
                <label>{item.name}</label>
              </a>
            </div>
          ) : item.name == t('Profile') ||
            (item.name == t('Account history') && isEs) ? (
            <div className="loggedInTabs" key={index}>
              <a href={item.url} key={index} className="adaMenu whiteFocus">
                <span>
                  <img src={item.icon} height={28} width={28} alt="" />
                </span>
                <label>{item.name}</label>
              </a>
            </div>
          ) : item?.spanishLink ? (
            <div className="menuForEnEs">
              <a href={item.url} key={index} className="adaMenu">
                <span>
                  {item.name}&nbsp;&nbsp;
                  {item.showUserPoints && (
                    <label>${Number(userPoints?.amount)}</label>
                  )}
                </span>
                <img
                  src="/content/images/icons/chevron-right.svg"
                  className="rightArrow"
                  width={24}
                  height={24}
                />
              </a>
            </div>
          ) : (
            ''
          );
        })}
      <div className={`menuContent ${isFromFooter ? 'footerMenuContent' : ''}`}>
        <Accordion allowZeroExpanded="true">
          {rendererMenu?.map((item, index) => {
            return (
              <AccordionItem
                key={index}
                uuid={index}
                dangerouslySetExpanded={
                  typeof window === 'undefined' ||
                  (isFromFooter && isDesktop) ||
                  index === expandedItems
                }
              >
                {isFromFooter && isDesktop ? (
                  <div className="accordion__button disabledButton">
                    {item.heading}
                  </div>
                ) : (
                  <AccordionItemHeading
                    onClick={() => handleAccordionChange(index)}
                    onKeyDown={event =>
                      handleKeydownEventForAccordian(event, index)
                    }
                  >
                    <AccordionItemButton
                      tabIndex={0}
                      className="accordion__button adaMenu whiteFocus"
                    >
                      {item.heading}
                    </AccordionItemButton>
                  </AccordionItemHeading>
                )}
                {item?.links?.map((subItem, subIndex) => {
                  return (
                    <AccordionItemPanel key={subIndex}>
                      {subItem.subHeading && <span>{subItem.subHeading}</span>}
                      <a
                        className="adaMenu"
                        href={subItem.url}
                        {...subItem.others}
                        ref={ref}
                        onKeyDown={e => handleKeydownEvent(e, subIndex)}
                      >
                        {getTitle(subItem.name)}
                        {subItem?.icon && (
                          <img
                            src={subItem.icon}
                            width={12}
                            height={12}
                            alt=""
                          />
                        )}
                      </a>
                      {subItem.data && <p>{subItem.data}</p>}
                    </AccordionItemPanel>
                  );
                })}
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </>
  );
};

export default MenuAccordian;
